export default __webpack_public_path__ + "static/media/logo_delete_account.a9dfd783.png";